// the saved players Alpine object
window.appSavedPlayers = () => {
    return {
        players: [],
        selectedPlayers: [],
        activeMenus: [],

        /*
         * Initialise
         */
        init: function() {
            // default positions selected
            this.$store.positions = [];

            // default sort: age ascending
            this.$store.age = 'asc';
            this.$nextTick( () => this.$component('selectAge').label = this.$component('selectAge').items[0].label );

            this.loadPlayers();
        },

        /*
         * Select a player from the list
         */
        select: function(player) {
            // Already selected, then remove
            if( this.selectedPlayers.includes(player.id)) {
                this.selectedPlayers = this.selectedPlayers.filter( v => v != player.id );

            // otherwise add it if there is room
            } else {
                this.selectedPlayers.push(player.id);
            }
        },

        /*
         * Loads in the saved players from the API
         */
        loadPlayers: function() {
            axios.get('/api/saved-players/')
                .then( response => {
                    this.players = response.data;
                })
                .catch( ajaxFail )
        },

        /*
         * Deletes the selected players from the frontend players list and permentently via the API
         */
        deletePlayers: async function() {

            let msg;
            if(this.selectedPlayers.length === 1) {
                msg = getLang('confirm_delete_saved_player', {'%NAME%': this.players.find(v => v.id == this.selectedPlayers[0]).name});
            } else {
                msg = getLang('confirm_delete_saved_players');
            }
            const doDelete = await modalConfirm(msg, 'Delete');

            if( doDelete ) {
                axios.post('/api/saved-players/' + this.selectedPlayers.join(','), {'_method' : 'DELETE'})
                    .then( response => {
                        this.players = this.players.filter( v => ! this.selectedPlayers.includes(v.id));
                        this.selectedPlayers = []
                    })
                    .catch( ajaxFail )
            }
        },

        /*
         * Filter and sort the players
         */
        get filteredPlayers() {
            let r = this.players;

            // filter (if needed)
            if( this.$store.positions.length > 0 ) {
                let filteredPositions = [];
                this.$store.positions.forEach( pos => {
                    filteredPositions = filteredPositions.concat(window.positions.find(v => v.value == pos).positions);
                })
                r = r.filter(v => filteredPositions.includes(v.position));
            }

            // sort by age or value
            if(!africaMen()) {
                if( this.$store.age == 'asc' ) {
                    r.sort( (a, b) => +a.age === +b.age ? 0 : (+a.age > +b.age) ? 1 : -1 );
                } else if( this.$store.age == 'desc' ) {
                    r.sort( (a, b) => +a.age === +b.age ? 0 : (+a.age > +b.age) ? -1 : 1 );
                } else if( this.$store.minutes == 'asc' ) {
                    r.sort( (a, b) => +a.minutes === +b.minutes ? 0 : (+a.minutes > +b.minutes) ? 1 : -1 );
                } else if( this.$store.minutes == 'desc' ) {
                    r.sort( (a, b) => +a.minutes === +b.minutes ? 0 : (+a.minutes > +b.minutes) ? -1 : 1 );
                }
            } else {
                if( this.$store.age == 'asc' ) {
                    r.sort( (a, b) => +a.age === +b.age ? 0 : (+a.age > +b.age) ? 1 : -1 );
                } else if( this.$store.age == 'desc' ) {
                    r.sort( (a, b) => +a.age === +b.age ? 0 : (+a.age > +b.age) ? -1 : 1 );
                } else if( this.$store.minutes == 'asc' ) {
                    r.sort( (a, b) => +a.minutes === +b.minutes ? 0 : (+a.minutes > +b.minutes) ? 1 : -1 );
                } else if( this.$store.minutes == 'desc' ) {
                    r.sort( (a, b) => +a.minutes === +b.minutes ? 0 : (+a.minutes > +b.minutes) ? -1 : 1 );
                }
            }

            return r;
        }
    }
};
